// extracted by mini-css-extract-plugin
export default {"menuWrapper":"Menu_menuWrapper__8dlPo","menuItem":"Menu_menuItem__l95NT","activeMenuitem":"Menu_activeMenuitem__w4u-i"};